import { AppThunk } from "@Store/index";
import { fetchSearchDataIfNeed } from "./searchPageReducer";

const loadData = (props: any): AppThunk[] => [
  fetchSearchDataIfNeed(props),
  // More pre-fetched actions...
];

export default loadData;
